// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInISOWeekYears as fn } from "../differenceInISOWeekYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInISOWeekYears = convertToFP(fn, 2);

// Fallback for modularized imports:
export default differenceInISOWeekYears;
